import {connect} from 'react-redux';
import Manage from './Manage.jsx';

const mapStateToProps = state => ({
  entriesQty: state.registration.shared.entries.length,
  allRostersComplete: state.registration.shared.entries.every(e => { return e.rosterComplete; }),
  virtualEntriesQty: state.registration.shared.virtualEntries.length,
  rosterMessage: state.registration.base.rosterMessage,
  loadingEntries: state.registration.shared.loadingEntries,
  loadingVirtualEntries: state.registration.shared.loadingVirtualEntries
});

export default connect(mapStateToProps)(Manage);



// WEBPACK FOOTER //
// ./src/features/registration/manage/ManageContainer.jsx